import * as React from "react";
import { forwardRef, memo } from "react";
const SvgWf = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 150 100", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ED2939", d: "M0 0h150v100H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h40v40H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#002395", d: "M0 0h20v40H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "#FFF", d: "M0 40h60V0" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M105 46L93 34h24zm-4 4L89 38v24zm4 4L93 66h24zm4-4l12-12v24z" }));
const ForwardRef = forwardRef(SvgWf);
const Memo = memo(ForwardRef);
export default Memo;
